/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import {
  ICustomPropertyDefinitionCreate,
  ICustomPropertyDefinitionUpdate,
} from '../../models/custom-property/custom-property.model';

export class LoadCustomProperties {
  static readonly type = '[CustomProperty] Load Custom Properties via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadCustomPropertyById {
  static readonly type = '[CustomProperty] Load a single Custom Property';
  constructor(public id: string) {}
}

export class LoadCustomPropertyByVersion {
  static readonly type = '[CustomProperty] Load Custom Property by Version';
  constructor(
    public id: string,
    public versionId: string
  ) {}
}

export class CreateCustomProperty {
  static readonly type = '[CustomProperty] Create Custom Property';
  constructor(public customProperty: ICustomPropertyDefinitionCreate) {}
}

export class UpdateCustomProperty {
  static readonly type = '[CustomProperty] Update Custom Property';
  constructor(public customProperty: ICustomPropertyDefinitionUpdate) {}
}

export class DeleteCustomProperty {
  static readonly type = '[CustomProperty] Delete Custom Property';
  constructor(public id: string) {}
}

export class RestoreCustomProperty {
  static readonly type = '[CustomProperty] Restore Custom Property';
  constructor(public id: string) {}
}

export class ClearCurrentCustomProperty {
  static readonly type = '[CustomProperty] Clear Current Custom Property';
}
